// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ytA5W{position:absolute;top:0;width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;color:#fff}._18osv{background-color:#231815}.YK1dq,._2stWQ{margin-bottom:1.5rem}", ""]);
// Exports
exports.locals = {
	"root": "ytA5W",
	"comingSoon": "_18osv",
	"description": "YK1dq",
	"title": "_2stWQ"
};
module.exports = exports;
